import { PermissionLevels } from 'common/constants/permissions';
import { RouteItem } from 'types/route.types';
import { clubRouteItems } from 'constants/routeItems/routeItemLevelClub.constants';
import { corporationRouteItems } from 'constants/routeItems/routeItemLevelCorporation.constants';
import { peakRouteItems } from 'constants/routeItems/routeItemLevelPeak.constants';

export function getPermissionLevelRouteItems(level: PermissionLevels): RouteItem[] {
  switch (level) {
    case PermissionLevels.CLIENT: {
      return clubRouteItems;
    }
    case PermissionLevels.CORPORATE: {
      return corporationRouteItems;
    }
    case PermissionLevels.PEAK: {
      return peakRouteItems;
    }
    default: {
      return [];
    }
  }
}
